// extracted by mini-css-extract-plugin
export var border = "_2l-8";
export var brand = "_2l-t";
export var button = "_2l-l";
export var center = "_2l-a";
export var centered = "_2l-6";
export var closeButton = "_2l-c";
export var disabledWrapper = "_2l-m";
export var error = "_2l-p";
export var extraLarge = "_2l-4";
export var extraSmall = "_2l-1";
export var fill = "_2l-i";
export var footer = "_2l-h";
export var footerAction = "_2l-j";
export var footerButtons = "_2l-k";
export var header = "_2l-7";
export var headerWithClose = "_2l-d";
export var icon = "_2l-o";
export var info = "_2l-s";
export var inline = "_2l-9";
export var large = "_2l-3";
export var main = "_2l-e";
export var modal = "_2l-0";
export var nearFull = "_2l-5";
export var neutral = "_2l-u";
export var noPadding = "_2l-g";
export var none = "_2l-v";
export var scrollable = "_2l-f";
export var small = "_2l-2";
export var success = "_2l-r";
export var tight = "_2l-n";
export var titleIcon = "_2l-b";
export var warn = "_2l-q";